import { render, staticRenderFns } from "./EventTypeSelectorModal.vue?vue&type=template&id=ddf79a6c&"
import script from "./EventTypeSelectorModal.vue?vue&type=script&lang=js&"
export * from "./EventTypeSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports